import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'sourceGroupSettingsNav';
export const useSourceGroupSettingsNavTranslation = (): UseTranslationResponse<'widgets', typeof keyPrefix> => useTranslation('widgets', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    sections: {
      general: 'Общая информация',
      streams: 'Источники в группе',
      stream_settings: 'Параметры источников',
    },
    va_group: 'Видеоаналитики группы',
    add_analytics: 'Добавить',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    sections: {
      general: 'General information',
      streams: 'Sources in the group',
      stream_settings: 'Source parameters',
    },
    va_group: 'Group video analytics',
    add_analytics: 'Add',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    sections: {
      general: 'Información general',
      streams: 'Fuentes del grupo',
      stream_settings: 'Parámetros de fuentes',
    },
    va_group: 'Videoanalíticas del grupo',
    add_analytics: 'Añadir',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    sections: {
      general: 'Informações gerais',
      streams: 'Fontes do grupo',
      stream_settings: 'Parâmetros de fontes',
    },
    va_group: 'Videoanalíticas do grupo',
    add_analytics: 'Adicionar',
  },
}) : {}) as Record<string, unknown>;
